import { cva } from 'class-variance-authority';
const checkboxSizeMap = {
    default: 'size-[length:var(--choice-size)]',
    md: 'size-[length:var(--choice-size-md)]',
    sm: 'size-[length:var(--choice-size-sm)]',
    lg: 'size-[length:var(--choice-size-lg)]',
};
const checkboxIndicatorSizeMap = {
    default: 'size-3.5',
    md: 'size-3.5',
    sm: 'size-3',
    lg: 'size-4',
};
export const checkboxCva = {
    variants: {
        size: checkboxSizeMap,
    },
    defaultVariants: {
        size: 'default',
    },
};
export const checkboxVariants = cva('peer border-input dark:bg-input/30 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary data-[state=checked]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50', checkboxCva);
export const checkboxSizeKeys = Object.keys(checkboxCva.variants.size);
/** 체크 아이콘 크기 — Root size와 짝. */
export function checkboxIndicatorClass(size) {
    const key = size && size in checkboxIndicatorSizeMap ? size : 'default';
    return checkboxIndicatorSizeMap[key];
}
//# sourceMappingURL=checkbox.cva.js.map